class UZKitBuilder{
    varaintID = 0; 
    sectionID = 0;
    productFormID = 0;
    productForm = null;
    submitButton = null;
    competitionData = null;
    playerPickerType = "dropdown";
    selCompetitionData = null;
    personaliseData = {"competition_data":"", 
        "product":{"variant_id":""}, 
        "type": "player",
        "to_print":{
            "name":"",
            "number":"",
            "products":[],
        },
        "badges_products":[],
        "player_list_idx":0
    };
    personalise_name_regex = "";
    swearWords = {};
    additionalProperties = [];
    startPersonalise = false;
    savedVariant = null;

    constructor(competitionData, regex, swearWords ,playerPickerType, productFormID, sectionID, additionalProperties = {}){
        this.competitionData = competitionData;
        //console.log(this.competitionData);
        this.playerPickerType = playerPickerType;
        this.productFormID = productFormID;
        this.sectionID = sectionID;
        this.personalise_name_regex = regex;
        this.swearWords = swearWords;
        this.additionalProperties = additionalProperties;
        
    }
    showCompetitionData(){
        console.log(this.competitionData);
    }
    updatePreviewNumberCanvas(num){
        var canvas = document.getElementById("uzkb_preview_personalise_number_canvas");
        var ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
  
        var x = canvas.width / 2;
        var y = canvas.height / 2;

        if (this.selCompetitionData.svg_font_enabled === false) {
            ctx.font = "300px '"+this.selCompetitionData.font.name+"'";
            //console.log(this.selCompetitionData.font.name);
            ctx.fillStyle = this.selCompetitionData.font_color;
            ctx.textAlign = "center";
            ctx.fillText(num, x, y);
        } else {
            var svgImages = [];
            var svgImageLoadCount = 0;

            for (let num_segment in num) {
                let svgNumImg = new Image;
                svgNumImg.src = this.selCompetitionData.svg_numbers["num_" + num[num_segment]];
                svgImages.push(svgNumImg);
            }

            for (let i = 0; i < svgImages.length; i++) {
                svgImages[i].onload = function() {
                    svgImageLoadCount++;
                    if (svgImageLoadCount === svgImages.length) {
                        renderSvgNumbers();
                    }
                }
            }

            var renderSvgNumbers = function() {
                let totalWidth = 0;
                let startPosition = x;
                let imagePositionData = [];
                let offset = 0;
                let svgSpacing = 20;
                let svgHeight = 300;


                for (let svgNumImgLoaded in svgImages) {
                    let loadedSvgImage = svgImages[svgNumImgLoaded];
                    let ratio = loadedSvgImage.naturalWidth / loadedSvgImage.naturalHeight;
                    totalWidth += (svgHeight * ratio);
                    imagePositionData.push({
                        image: loadedSvgImage,
                        ratio: ratio,
                        width: (svgHeight * ratio)
                    })
                }
                totalWidth += (svgImages.length - 1) * svgSpacing;
                let midPoint = totalWidth / 2;
                startPosition -= midPoint;
                for (let renderImage in imagePositionData) {
                    ctx.drawImage(imagePositionData[renderImage].image, startPosition + offset, 0, imagePositionData[renderImage].width, svgHeight);
                    offset += imagePositionData[renderImage].width + svgSpacing;
                }
            }
        }
    }
    showPersonalisePreview(){
        if (!this.startPersonalise)
            return;
        $("#kit_builder_player_picker").removeClass("uzkb__errors_field");
        $("#kit_builder_name_input").removeClass("uzkb__errors_field");
        $("#kit_builder_number_picker").removeClass("uzkb__errors_field");
        $("#uzkb_form_errors").hide();
        var _previewIdx = this.selCompetitionData.preview_image_index
        $(".thumbnail-list li.thumbnail-list__item:nth-child("+_previewIdx+")").find("button").trigger("click");
        var _num = this.personaliseData.to_print.number;
        if ((_num.length == 1) && (_num != "-")) {
            //$("#uzkb_preview_personalise_number").html('<img src="https://cdn.shopify.com/s/files/1/0726/6369/5675/files/'+_num+'.png?v=1684068542" />');
            $("#uzkb_preview_personalise_number_text").html(_num);
            this.updatePreviewNumberCanvas(_num);
        } else if (_num.length == 2) {
            var _numArr = _num.split("");
            //$("#uzkb_preview_personalise_number").html('<img src="https://cdn.shopify.com/s/files/1/0726/6369/5675/files/'+_numArr[0]+'.png?v=1684068542" /><img src="https://cdn.shopify.com/s/files/1/0726/6369/5675/files/'+_numArr[1]+'.png?v=1684068542" />');
            $("#uzkb_preview_personalise_number_text").html(_num);
            this.updatePreviewNumberCanvas(_num);
        } else {
            $("#uzkb_preview_personalise_number_text").html('');
            this.updatePreviewNumberCanvas("");
        }
    
        $("#uzkb_preview_personalise_name_text").html(this.personaliseData.to_print.name.toUpperCase());
        
        //console.log("_sel_player_vid: "+_sel_player_vid);
        //
       $("#uzkb_preview_badge_left").html("");
       $("#uzkb_preview_badge_right").html("");
       $("#uzkb_preview_badge_bottom").html("");
            
       Object.entries(this.personaliseData.badges_products).forEach(([key, value], index) => {
            Object.entries(this.personaliseData.competition_data.badges).forEach(([k, v], i) => {
                if (v.product.variant_id == value){
                    //console.log(v.position);
                    if (v.position == 1 && (v.preview_img != "")){
                        $("#uzkb_preview_badge_left").html('<img src="'+v.preview_img+'" />')
                    }
                    if (v.position == 2 && (v.preview_img != "")){
                        $("#uzkb_preview_badge_right").html('<img src="'+v.preview_img+'" />')
                    }
                    if (v.position == 3 && (v.preview_img != "")){
                        $("#uzkb_preview_badge_bottom").html('<img src="'+v.preview_img+'" />')
                    }
                }
            });
            
        });
        console.log(this.personaliseData);
       
    }
    init(){
        //get preset options
        var _vid = kitBuilderUtility.getQueryVariable("variant");
        var _compeition_style_index = 0;
        var _compeition_style_id = kitBuilderUtility.getQueryVariable("cs");
        var _personalise_type = kitBuilderUtility.getQueryVariable("type");
        var _print_name = decodeURI(kitBuilderUtility.getQueryVariable("pName"));
        var _print_number = kitBuilderUtility.getQueryVariable("pNumber");
        var _print_products = kitBuilderUtility.getQueryVariable("pProducts");
        var _badges = kitBuilderUtility.getQueryVariable("badges");
        var _pcidx = kitBuilderUtility.getQueryVariable("pcidx");
        
        // number picker set drop down value: 1-99
        for (var i=1;i<=99;i++){
            $("#kit_builder_number_picker").append($('<option>', { 
                value: i,
                text : i 
            }));
        }
        var _initPreviewIdx = this.competitionData.length > 0 ? this.competitionData[0].preview_image_index : 2;
        $(".product__media-list li.product__media-item:nth-child("+_initPreviewIdx+")").find(".product-media-container").append($("#uzkb_personalise_preview_html").html());
    
        //hide competition style selector if only one compeitiion
        if (this.competitionData.length>=2){
            $(".uzkb__compeition_picker").show();
        }

        $('#kit_builder_name_input').keydown(function (event) { 
            /*
            var rgx = new RegExp(this.swearWords.join("|")+'|fuck\\b', 'gi');
            //console.log(rgx);
            const myArray = rgx.exec(val);
            //console.log(myArray); 
            if (myArray != null){
            return true;
            } else {
            return false;
            }
            */
           //console.log(kitBuilder.personalise_name_regex);
           var rgx = new RegExp("["+kitBuilder.personalise_name_regex+"]", 'i');
           
           //var rgx = new RegExp("[a-zA-Z \\-\\_.']", 'i');
            ///[a-zA-Z -.']/i
            return rgx.test(event.key);
        });
        //set name input keyup event
        $('#kit_builder_name_input').keyup(function (event) {  
            var rgx = new RegExp("[^"+kitBuilder.personalise_name_regex+"]", 'g');
           
            var _val = $(this).val().toUpperCase();
            _val = _val.replace(rgx, '');
            $(this).val(_val);
          $(this).get(0).setCustomValidity("");
            
            $(".uzkb_preview_personalise_container").removeClass("foul");
            //$(this).removeClass("input-error");
            var _isSwearWord = kitBuilder.isSwearWord(_val);
            if (_isSwearWord){
              $(".uzkb_preview_personalise_container").addClass("foul");
              $(this).get(0).setCustomValidity(uzkd_config.not_allow_swear_words);
              $(this).get(0).reportValidity();
              //$(this).addClass("input-error");
            }
            kitBuilder.setPersonaliseData({"action":"update_name", data:{"isSwearWord":_isSwearWord, "name":_val}});

        });
        
      /*$('#kit_builder_name_input').on( "change", function() {
            //console.log("name change");
            var rgx = new RegExp("[^"+kitBuilder.personalise_name_regex+"]", 'g');
           
            var _val = $(this).val().toUpperCase();
            _val = _val.replace(rgx, '');
            $(this).val(_val); 
            
            $(this).get(0).setCustomValidity("");
            
            $(".uzkb_preview_personalise_container").removeClass("foul");
            //$(this).removeClass("input-error");
            var _isSwearWord = kitBuilder.isSwearWord(_val);
            if (_isSwearWord){
              $(".uzkb_preview_personalise_container").addClass("foul");
              $(this).get(0).setCustomValidity("Swear Word Not Allowed");
              $(this).get(0).reportValidity();
              //$(this).addClass("input-error");
            }
            kitBuilder.setPersonaliseData({"action":"update_name", data:{"isSwearWord":_isSwearWord, "name":_val}});
        });*/

        $('#kit_builder_number_picker').on( "change", function() {
            kitBuilder.setPersonaliseData({"action":"update_number", data:$("#kit_builder_number_picker").find('option:selected').val()});
        });
    
        $("#kit_builder_player_picker").on( "change", function() {
            kitBuilder.setPlayer(this);
        });
    
        //set player pickup event for popup
        if (this.playerPickerType == "popup" ){
            $("#kit_builder_player_picker").addClass("uzkd__select__popup");
            $(".uzkb__player_picker .select").click(function() {
            //$("#kit_builder_player_picker").on( "click", function() {
                kitBuilder.showPlayerPickerPopup();
            });
        }

        this.submitButton = $(".uzkb_buy_button");

        this.submitButton.click(function(event){
            kitBuilder.onSubmitHandler(event);
        });

        this.productForm = document.querySelector('product-form');
        
        //console.log(this.competitionData);
        //set preset data

        for (var i = 0;i< this.competitionData.length;i++){
            if (this.competitionData[i].id == _compeition_style_id){
                this.startPersonalise = true;
                _compeition_style_index = i;
            }
        }
        $("#kit_builder_competition_"+_compeition_style_index).trigger("click");

        //preset the player collection idx
        if (_pcidx != ""){
          if (isNaN(parseInt(_pcidx))){
            this.personaliseData.player_list_idx = 0;  
          } else {
            this.personaliseData.player_list_idx = parseInt(_pcidx);
          }
          
          this.updatePlayerPickerList();
        }
        if (_personalise_type == "player"){
            $("#kit_builder_personalise_type_player").trigger("click");
        } else if (_personalise_type == "your_own"){
            $("#kit_builder_personalise_type_your_own").trigger("click");
        } else {
            // if (this.selCompetitionData.players.length == 0){
            //     _personalise_type = "none";
            //     $("#kit_builder_personalise_type_none").trigger("click");
            // } else {
            //     $("#kit_builder_personalise_type_player").trigger("click");
            // }
            _personalise_type = "none";
            $("#kit_builder_personalise_type_none").trigger("click");
        }

        if (_print_products != ""){
            this.startPersonalise = true;
            _print_products = _print_products.split(",");
            if (_personalise_type == "player"){
                $("#kit_builder_player_picker").find('option:selected').removeAttr("selected");
                //$("#kit_builder_player_picker option[value="+_print_products[0]+"]").attr('selected','selected').change();
                $("#kit_builder_player_picker option[value="+_print_products[0]+"]").prop('selected',true).change();
            } else {
                // if (this.selCompetitionData.product_type==0){
                //     //short 
                //     this.personaliseData.to_print.products = [this.personaliseData.competition_data.personalise_number_product.variant_id];
                // } else {
                //     this.personaliseData.to_print.products = [this.personaliseData.competition_data.personalise_name_product.variant_id, this.personaliseData.competition_data.personalise_number_product.variant_id];
                // }

                //this.setPersonaliseData({"action":"update_name", data:{"isSwearWord":false, "name":_print_name}});
                //this.setPersonaliseData({"action":"update_number", data:_print_number});
                if (_print_name != "" ){
                    $("#kit_builder_name_input").val(_print_name).change(); 
                    kitBuilder.setPersonaliseData({"action":"update_name", data:{"isSwearWord":false, "name":_print_name}});
                }
                //alert(_print_name);
                _print_number = parseInt(_print_number);
                //alert(_print_number);
                if (_print_number>0){
                    //$("#kit_builder_number_picker option[value="+_print_number+"]").attr('selected','selected').change();
                    //kitBuilder.setPersonaliseData({"action":"update_number", data:_print_number});
                    $("#kit_builder_number_picker option[value="+_print_number+"]").prop('selected',true).change();
                }
            }
        }

        //preset the badges
        if (_badges != ""){
            this.startPersonalise = true;
            _badges = _badges.split(",");
            $(".kit_builder_badge").each(function(){
                if ($(this).val() == 0){
                    $(this).trigger("click");
                }
                for (var i = 0;i< _badges.length;i++){
                    if ($(this).val() == _badges[i]){
                        $(this).trigger("click");
                    }
                }
            });
        }
        
        this.startPersonalise = true;
    }
    
    setCompetition(idx){
        //console.log("setCompetition");
        //set selected competition data;
        this.selCompetitionData = this.competitionData[idx];
        this.setPersonaliseData({action:"reset_competition", data:this.selCompetitionData});

        const personalisationContainer = document.querySelector('.uzkb_preview_personalise_container');
        personalisationContainer.setAttribute('data-font', this.selCompetitionData.font.name);

        //rebuild player picker list
        this.personaliseData.player_list_idx = 0;

        this.updatePlayerPickerList();
        
        //set personalise type price to ui
        let _personalise_player_price = 16;
        if (this.selCompetitionData.players.length > 0){
            _personalise_player_price = (parseInt(this.selCompetitionData.players[0].price)) /100;
        }
        $("#kit_builder_personalise_type_player_label").find(".personalise_price").html(" +"+currencySymbol+_personalise_player_price);
        this.updateYourOwnLablePrice();
        //set name curve
        if (this.selCompetitionData.name_curve=="1"){
            $("#uzkb_preview_personalise_name_container").html('<defs><path id="MyPath" d="M92,125A1,1,0,0,1,292,135"></path></defs><text text-anchor="middle"><textPath xlink:href="#MyPath" id="uzkb_preview_personalise_name_text" startOffset="49.5%">'+this.personaliseData.to_print.name+'</textPath></text>');
        } else {
            $("#uzkb_preview_personalise_name_container").html('<text x="50%" y="20%" dominant-baseline="middle" text-anchor="middle" id="uzkb_preview_personalise_name_text">'+this.personaliseData.to_print.name+'</text>');
        }
        
        if (this.selCompetitionData.product_type==0){
            //short
            $("#kit_builder_personalise_type_player_label").hide();
            $("#kit_builder_name_input_item").hide();
            $(".uzkb_preview_personalise_container").addClass("ukb_preview_short");
            
        } else {
            //shirt
            $("#kit_builder_personalise_type_player_label").show();
            $("#kit_builder_name_input_item").show();
            $(".uzkb_preview_personalise_container").removeClass("ukb_preview_short");
        }
        //console.log(this.selCompetitionData);
        
        //set peronslise preview font style 
        $("#uzkb_preview_personalise_name_text").css({"font-family":"\'"+this.selCompetitionData.font.name+"\'", "fill":this.selCompetitionData.font_color});
        $("#uzkb_preview_personalise_number_text").css({"font-family":"\'"+this.selCompetitionData.font.name+"\'", "fill":this.selCompetitionData.font_color});
        if (this.selCompetitionData.product_type==0){
            //short
            $("#uzkb_preview_personalise_number_text").attr("x", "72%");
        }
        $("#uzkb_name_max_remark").html("Maximum "+this.selCompetitionData.name_length+" characters");
        $("#kit_builder_name_input").attr("maxlength", this.selCompetitionData.name_length);

        //set badge picker list
        this.updateBadgePickerList();
        //$(".uzkb__make_your_own").show();
       //console.log(this.personaliseData);

       //$("#kit_builder_personalise_type_player").trigger("click");

    }
    setPersonaliseType(type){
        if (type=="none"){
            $(".uzkb__make_your_own").hide();
            $(".uzkb__player_picker ").hide();
            $(".uzkb__badge_picker").show();
            $("#uzkb_preview_personalise_name").hide()
            $("#uzkb_preview_personalise_number").hide();
            
            kitBuilder.setPersonaliseData({"action":"update_personalise_type", data:"none"});
        } else if (type=="player") {
            $(".uzkb__make_your_own").hide();
            $(".uzkb__player_picker ").show();
            $(".uzkb__badge_picker").show();
            $("#uzkb_preview_personalise_name").show()
            $("#uzkb_preview_personalise_number").show();
            
            
            kitBuilder.setPersonaliseData({"action":"update_personalise_type", data:"player"});
        } else {
            $(".uzkb__make_your_own").show();
            $(".uzkb__player_picker ").hide();
            $(".uzkb__badge_picker").show();
            $("#uzkb_preview_personalise_name").show()
            $("#uzkb_preview_personalise_number").show();
            
            kitBuilder.setPersonaliseData({"action":"update_personalise_type", data:"your_own"});
        }
    }
    updateBadgeRequired(){
        if (kitBuilder.personaliseData.type == "none"){
            $(".uzkd-grid-badge").each(function(){
                $(this).find(".grid__item:first-child").show();
                
            });
        } else {
            //for badge required
            if (kitBuilder.selCompetitionData.badge_required){
                $(".uzkd-grid-badge").each(function(){
                    $(this).find(".grid__item:first-child").hide();
                    $(this).find(".grid__item").each(function(idx, badge_grid_item_ele){
                        //console.log(badge_grid_item_ele);
                        $(badge_grid_item_ele).find(".kit_builder_badge").each(function(idx, badge_input_ele){
                            //console.log(badge_input_ele);
                            if ($(badge_input_ele).val() != "0"){
                                $(badge_input_ele).trigger("click");
                                //alert("click");
                            }
                        })
                    });
                });
            }
        }
        
    }
    badgeSamePositionChecker(request){
      
        // for (var i=0;i < this.personaliseData.badges_products.length;i++){
        //   console.log(this.personaliseData.badges_products[i]);
        // }
        
        
        // var badgeClicked = this.selCompetitionData.badges[request.data.idx];
        
        // //console.log(badgeClicked);
        // var position = badgeClicked.position;
        // var badgePickerRadios = $(".kit_builder_badge");
        // badgePickerRadios.each(function(){
        //   console.log($(this).attr("name"));
        // });
        //hide same position badge picker
        if (request.action == "add_badge"){
          $(".uzkd-grid-badge").each(function(){
            if ( (parseInt($(this).data("position")) == parseInt(request.data.position) && (!$(this).hasClass("uzkd-grid-badge-"+request.data.idx)))){
              //console.log("disabled");
              $(this).parent().addClass("disabled");
            }
          })
        }
        if (request.action == "remove_badge"){
          $(".uzkd-grid-badge").each(function(){
            if ( (parseInt($(this).data("position")) == parseInt(request.data.position))){
              //console.log("disabled");
              $(this).parent().removeClass("disabled");
            }
          })
        }
      }
    updateBadgePickerList(){
        $(".uzkb__badge_picker").html("");
        /*
        <fieldset class="js product-form__input">
      <legend class="form__label">Badge</legend>
      <ul class="contains-content-container uzkd-grid-badge">
        <li class="grid__item">
          <input type="radio" onchange="changeBadge(0)" name="kit_builder_badge_1" id="kit_builder_badge_1_0" value="0" form="product-form-template--19100267282747__main">  
          <label for="kit_builder_badge_1_0" class="badge-label badge-label-img">None</label>
        </li>
        <li class="grid__item">
        <input type="radio" onchange="changeBadge(1)" checked="" name="kit_builder_badge_1" id="kit_builder_badge_1_1" value="1" form="product-form-template--19100267282747__main"> 
          <label for="kit_builder_badge_1_1" class="badge-label-img">Sky Bet Championship
          <img src="https://dev.shop.qpr.co.uk/static/version1681815208/frontend/qpr/default/en_GB/images/badge.png"></label>
        </li>
      </ul>
    </fieldset>
        */
        let _minimumFractionDigits = 2;
        if (Shopify.currency_format == "without-decimals"){
            _minimumFractionDigits = 0;
        }
        let _money = Intl.NumberFormat('en', {
            style: 'currency',
            currency: Shopify.currency.active,
            minimumFractionDigits:_minimumFractionDigits
        });
        for (var i=0;i<this.selCompetitionData.badges.length;i++){
            var available = this.selCompetitionData.badges[i].product.available;
            var soldOutClass = "";
            var noneChecked = "checked";
            var badgeChecked = "";
            var noneOnClickEvent = "";
            var badgeOnClickEvent = "";
            var badgeRadioName = "kit_builder_badge_"+i;
            var noneBadgeRadioID = badgeRadioName+"_0";
            var badgeRadioID = badgeRadioName+"_1";
            var noneLabelOnClickEvent = "kitBuilder.badgeLabelClick(event, '"+badgeRadioName+"', true)";
            var badgeLabelOnClickEvent = "kitBuilder.badgeLabelClick(event, '"+badgeRadioName+"',false)";
            var noneOnChangeEvent = "kitBuilder.setBadge({'action':'remove_badge','data':{ 'idx':"+i+", position:"+this.selCompetitionData.badges[i].position+", 'vid':"+this.selCompetitionData.badges[i].product.variant_id+"}})";
            var badgeOnChangeEvent = "kitBuilder.setBadge({'action':'add_badge','data':{ 'idx':"+i+", position:"+this.selCompetitionData.badges[i].position+", 'vid':"+this.selCompetitionData.badges[i].product.variant_id+"}})";
            var badgeButtonStyle = "";
            if (available == "false"){
                soldOutClass = "sold_out";
                noneChecked = "checked";
                badgeChecked = "";
                noneOnClickEvent = "return false";
                badgeOnClickEvent = "return false";
                noneOnChangeEvent = "return false";
                badgeOnChangeEvent = "return false";
            
            }
            if (this.selCompetitionData.badge_button_style == "2"){
              //toggle style
              badgeButtonStyle = "uzkd-grid-badge_toggle";
            }
            var _html = '<fieldset class="js product-form__input '+soldOutClass+'">';
            _html += '<legend class="form__label">'+this.selCompetitionData.badges[i].label+'</legend>';
            _html += '<ul class="contains-content-container uzkd-grid-badge '+badgeButtonStyle+' uzkd-grid-badge-'+i+'" data-position="'+this.selCompetitionData.badges[i].position+'">';
            _html += '<li class="grid__item">';
            _html += '<input type="radio" class="kit_builder_badge kit_builder_badge_none" '+noneChecked+' onchange="'+noneOnChangeEvent+'"  onclick="'+noneOnClickEvent+'" name="'+badgeRadioName+'" id="'+noneBadgeRadioID+'" value="0">';
            _html += '<label for="kit_builder_badge_'+i+'_0" class="badge-label badge-label-img" onclick="'+noneLabelOnClickEvent+'">None</label>';
            _html += '</li>';
            _html += '<li class="grid__item">';
            _html += '<input type="radio" class="kit_builder_badge" '+badgeChecked+' onchange="'+badgeOnChangeEvent+'" onclick="'+badgeOnClickEvent+'" name="'+badgeRadioName+'" id="'+badgeRadioID+'" value="'+this.selCompetitionData.badges[i].product.variant_id+'">';
            _html += '<label for="kit_builder_badge_'+i+'_1" class="badge-label-img" onclick="'+badgeLabelOnClickEvent+'">'+this.selCompetitionData.badges[i].product.title+' <b> +'+_money.format(parseFloat(this.selCompetitionData.badges[i].product.price)/100)+"</b>";
            _html += '<img src="'+this.selCompetitionData.badges[i].product.image+'"></label>';
            _html += '</li>';
            _html += '</ul>';
            _html += '</fieldset>';
            $(".uzkb__badge_picker").append(_html);
        }
        //$(".uzkb__badge_picker").find(".contains-content-container").html("");
    }
    updatePlayerPickerList(){
        //called when change competition style
        //set the player list from selCompetitionData.player_collections default the first one  
        /*this.personaliseData.to_print = {
                    "name":"",
                    "number":"",
                    "products":[]
                }*/
        if (this.selCompetitionData.player_collections.length > 0){
          this.selCompetitionData.players = this.selCompetitionData.player_collections[this.personaliseData.player_list_idx].players;
        } else {
          //empty the player list
          this.selCompetitionData.players = [];
        }
        //get selected player and preset after rebuilt the player list
        let _sel_player_vid = $("#kit_builder_player_picker").find('option:selected').val();
        
        $("#kit_builder_player_picker").empty();
        $("#kit_builder_player_picker").append('<option value="0">-- Please Select --</option>')
        $("#kit_builder_player_picker option[value=0]").prop('selected',true).change();
        
        if (this.selCompetitionData.players.length == 0){
            $("#kit_builder_personalise_type_player_label").hide();
            
        } else {
            for (var i=0;i<this.selCompetitionData.players.length;i++){
                let _selected = "";
                if (this.selCompetitionData.players[i].variant_id == _sel_player_vid){
                    _selected = "selected"
                }
                $("#kit_builder_player_picker").append('<option '+_selected+' available="'+this.selCompetitionData.players[i].available+'" img="'+this.selCompetitionData.players[i].image+'" value="'+this.selCompetitionData.players[i].variant_id+'">'+this.selCompetitionData.players[i].title+'</option>')
            }
        }

    }
    updatePlayerCollection(idx){
      this.personaliseData.player_list_idx =idx;
      this.updatePlayerPickerList();
      this.showPlayerPickerPopup();
      
    }
    showPlayerCollectionPicker(){
      if (this.selCompetitionData.player_collections.length > 1){
        var _playerCollectionPickerHTML = '';
        for (let i = 0;i < this.selCompetitionData.player_collections.length;i++){
          var collection = this.selCompetitionData.player_collections[i];
          var collectionClass="";
          if (this.personaliseData.player_list_idx == i){
            collectionClass = "active";
          }
          _playerCollectionPickerHTML += `<div class="uzkb_player_collection_item ${collectionClass}" data-handle="${collection.handle}" data-id="${collection.id}" data-idx="${i}" onclick="kitBuilder.updatePlayerCollection(${i})">${collection.title}</div>`; 
          //console.log(collection);
        }
        $("#uzkb_player_collection_list").html(_playerCollectionPickerHTML);
        $("#uzkb_player_collection_list").show();
      } else {
        $("#uzkb_player_collection_list").html("");
        $("#uzkb_player_collection_list").hide();
      }
      return;
    }
    showPlayerPickerPopup(){
        $("#kit_builder_player_picker").blur();
        if ($("#uzkb_player_picker_container").length>0){
            $("#uzkb_player_picker_container").remove();
        }
            var _playerPickerPopupHTML = '<div class="uzkb_player_picker_container color-background-1" id="uzkb_player_picker_container"><div class="uzkb_player_picker_close" onclick="kitBuilder.hidePlayerPickerPopup()"><i class="fa-solid fa-circle-xmark"></i></div><div id="uzkb_player_collection_list"></div><div id="uzkb_player_list">';
            $("#kit_builder_player_picker > option").each(function() {
                //console.log(this.text + ' ' + this.value);
                var avaliable = $(this).attr("available");
                var image = $(this).attr("img");
                var imageHTML = "";
                if (image !=null && image.length >= 10){
                  imageHTML = '<div class="player_img"><img src="'+image+'" /></div>';
                }
                var onClickEvent = 'kitBuilder.pickPlayer('+this.value+')';
                var soldOutClass = "";
                if (avaliable == "false"){
                    onClickEvent = ""
                    soldOutClass = "sold_out";
                } 
                _playerPickerPopupHTML +='<div class="uzkb_player_item '+soldOutClass+'" onClick="'+onClickEvent+'">'+imageHTML+this.text+'</div>';
                
            });
            _playerPickerPopupHTML +='</div></div>';
            $("body").append(_playerPickerPopupHTML);
        this.showPlayerCollectionPicker();
        $("#uzkb_player_picker_container").show();
        
        return false;
    }
    hidePlayerPickerPopup(){
        $("#uzkb_player_picker_container").hide();
    }
    pickPlayer(val){
        $("#kit_builder_player_picker").find('option:selected').removeAttr("selected");
        //$("#kit_builder_player_picker option[value="+val+"]").attr('selected','selected').change();
        $("#kit_builder_player_picker option[value="+val+"]").prop('selected',true).change();
        this.hidePlayerPickerPopup();
        
    }
    setPlayer(val){
        const _text = $("#kit_builder_player_picker").find('option:selected').text();
        const _img = $("#kit_builder_player_picker").find('option:selected').attr("img");
        //console.log(_img);
        var _imgHTML = "";
        if (_img !=null && _img.length >= 10){
            _imgHTML = '<div class="player_img"><img src="'+_img+'" /></div>';
        }
        const _val = $("#kit_builder_player_picker").find('option:selected').val();
        var playerName = "";
        var playerNumber = "-";
        var products = [_val];
        //var isPalyer = false;
        //alert(_val);
        if (_val != "0" ){
            var playerProduct = this.personaliseData.competition_data.players.filter((x) => x["variant_id"] == _val)
            //console.log(playerProduct);
            if (_text != ""){
                const playerInfoArr = _text.split(" - ");
                //console.log(playerArr);
                /**HOTFIX START 14JUL26 */
                if (playerInfoArr.length == 2){
                    playerName = playerInfoArr[0];
                    playerNumber = playerInfoArr[1];
                }
                /**
                if (playerInfoArr.length == 2){
                    const playerNameArr = playerInfoArr[0].split(" "); 
                    //console.log(playerNameArr);
                    if (playerNameArr.length >=2){
                      playerName = playerNameArr[1];
                    } else {
                      playerName = playerNameArr[0];
                    }
                    playerNumber = playerInfoArr[1];
                }
                */
                /**HOTFIX END */
                //$(".uzkb__make_your_own").hide();
                //isPalyer = true;
                $(".uzkb__player_picker .select").removeClass("no-player");
                $(".uzkb__player_picker .select .player-text").html(_imgHTML+_text);
                //add preview letter style if set
                if (playerProduct.length > 0)
                if ((playerProduct[0]["letter_style"] == "" || playerProduct[0]["letter_style"] == "L" ) ){
                  $("#uzkb_preview_personalise_name").removeClass("letter_XS");
                  $("#uzkb_preview_personalise_name").removeClass("letter_S");
                  $("#uzkb_preview_personalise_name").removeClass("letter_M");
                  $("#uzkb_preview_personalise_name").removeClass("letter_L");
                    
                } else {
                  $("#uzkb_preview_personalise_name").addClass("letter_"+playerProduct[0]["letter_style"]);
                }
            } else {
                //$(".uzkb__make_your_own").show();
                //products = [this.personaliseData.competition_data.personalise_name_product.variant_id, this.personaliseData.competition_data.personalise_number_product.variant_id];
                products = [];
                //isPalyer = false;
                $(".uzkb__player_picker .select").addClass("no-player");
            }
        } else {
            //$(".uzkb__make_your_own").show();
            //products = [this.personaliseData.competition_data.personalise_name_product.variant_id, this.personaliseData.competition_data.personalise_number_product.variant_id];
            products = [];
            $(".uzkb__player_picker .select").addClass("no-player");

            //isPalyer = false;
            
        }
        this.setPersonaliseData({"action":"update_player", data:{"name":playerName, "number":playerNumber, products:products}});
        
        
    }
    setBadge(request){
        //console.log(request);
        this.setPersonaliseData(request);
        
    }
    badgeLabelClick(event, name, isNone){
        console.log("badgeClick: "+name);
        if (kitBuilder.selCompetitionData.badge_button_style == "2"){
          //toggle handler
          if ((kitBuilder.personaliseData.type == "none") || !kitBuilder.selCompetitionData.badge_required){
            //handle toggle when personalise type == none
            if (isNone){
              if ($("#"+name+"_0").prop("checked")){
                $("#"+name+"_1").trigger("click");
                event.preventDefault();
              } 
            } else {
              if ($("#"+name+"_1").prop("checked")){
                $("#"+name+"_0").trigger("click");
                event.preventDefault();
              }
            }
          }
          
        }
      }
      updateFormLineItem(){
        //console.log("{{product_form_installment_id}}");
        //$("#{{product_form_id}} input[name='id']").remove();
        //$("#{{product_form_id}}").append('<input type="hidden" name="items[0][quantity]" value="1">');
        //$("#{{product_form_id}}").append('<input type="hidden" name="items[0][id]" value="45211441594683">');
        //$("#{{product_form_id}}").append('<input type="hidden" name="items[1][quantity]" value="1">');
        //$("#{{product_form_id}}").append('<input type="hidden" name="items[1][id]" value="45223437533499">');
        
      }
      setPersonaliseData(request){
        
        if (request.action == "reset_competition"){
            this.personaliseData.competition_data = request.data;
            this.personaliseData.badges_products = [];
            
            /*
            for (var i=0;i<this.personaliseData.competition_data.badges.length;i++){
                //defautl select all badge
                if (this.personaliseData.competition_data.badges[i].product.available == "true"){
                    this.personaliseData.badges_products.push(this.personaliseData.competition_data.badges[i].product.variant_id);
                }
            }
            */

            /*
            //check current user selection
            if (this.personaliseData.type == "none"){
                this.personaliseData.to_print = {
                    "name":"",
                    "number":"",
                    "products":[]
                }
                this.personaliseData.badges_products = [];
            } else if (this.personaliseData.type == "player"){
                //check is user selected play found in new player list
                let _matchPlayer = false;
                Object.entries(this.personaliseData.competition_data.players).forEach(([key, player], index) => {
                    //console.log(player.variant_id+" : "+this.personaliseData.to_print.products);
                    if (player.variant_id == this.personaliseData.to_print.products[0]){
                        _matchPlayer = true;
                    }
                });
                if (!_matchPlayer){
                    //player not match, reset data
                    this.personaliseData.to_print = {
                        "name":"",
                        "number":"",
                        "products":[]
                    }
                }
                //and set the badges to new badge as default selected
                this.personaliseData.badges_products = [];
                for (var i=0;i<this.personaliseData.competition_data.badges.length;i++){
                    //defautl select all badge
                    this.personaliseData.badges_products.push(this.personaliseData.competition_data.badges[i].product.variant_id);
                }
                
            } else {
                //keep current to print value if your_own
                //and set the badges to new badge as default selected
                this.personaliseData.to_print = {
                    "name":"",
                    "number":"",
                    "products":[]
                }
                this.personaliseData.badges_products = [];
                for (var i=0;i<this.personaliseData.competition_data.badges.length;i++){
                    //defautl select all badge
                    this.personaliseData.badges_products.push(this.personaliseData.competition_data.badges[i].product.variant_id);
                }
            }*/
            
        }
        if (request.action == "update_to_print"){
            this.personaliseData.to_print = request.data;
        }
        
        if (request.action == "update_personalise_type"){
            if (request.data == "none"){
                this.personaliseData.type = "none";
                this.personaliseData.to_print.products = [];
                    
            } else if (request.data == "player"){
                this.personaliseData.type = "player";
                $("#kit_builder_player_picker").change();
            } else {
                this.personaliseData.type = "your_own";
                this.personaliseData.to_print.name = $("#kit_builder_name_input").val();
                if ($("#kit_builder_number_picker").find('option:selected').val() == "-"){
                    this.personaliseData.to_print.number = "";
                } else {
                    this.personaliseData.to_print.number = $("#kit_builder_number_picker").find('option:selected').val();
                }

                if (this.selCompetitionData.product_type==0){
                    //short 
                    //this.personaliseData.to_print.products = [this.personaliseData.competition_data.personalise_number_product.variant_id];
                    this.personaliseData.to_print.products = [];
                    if (this.personaliseData.to_print.number > 0){
                        if (!this.personaliseData.to_print.products.includes(this.personaliseData.competition_data.personalise_number_product.variant_id)){
                            this.personaliseData.to_print.products.push(this.personaliseData.competition_data.personalise_number_product.variant_id);
                        }
                    }
                } else {
                    //shirt
                    //this.personaliseData.to_print.products = [this.personaliseData.competition_data.personalise_name_product.variant_id, this.personaliseData.competition_data.personalise_number_product.variant_id];
                    this.personaliseData.to_print.products = [];
                    if (this.personaliseData.to_print.name.length > 0){
                        if (!this.personaliseData.to_print.products.includes(this.personaliseData.competition_data.personalise_name_product.variant_id)){
                            this.personaliseData.to_print.products.push(this.personaliseData.competition_data.personalise_name_product.variant_id);
                        }
                    }
                    if (this.personaliseData.to_print.number > 0){
                        if (!this.personaliseData.to_print.products.includes(this.personaliseData.competition_data.personalise_number_product.variant_id)){
                            this.personaliseData.to_print.products.push(this.personaliseData.competition_data.personalise_number_product.variant_id);
                        }
                    }
                }
            }
            if (kitBuilder.selCompetitionData.badge_required){
                kitBuilder.updateBadgeRequired();
            }
            
        }
        if (request.action == "update_player"){
            this.personaliseData.to_print = request.data;
        }
        if (request.action == "update_name"){
            this.personaliseData.to_print.name = request.data.name;
            if (this.personaliseData.to_print.name.length > 0){
                if (!this.personaliseData.to_print.products.includes(this.personaliseData.competition_data.personalise_name_product.variant_id)){
                    this.personaliseData.to_print.products.push(this.personaliseData.competition_data.personalise_name_product.variant_id);
                }
            } else {
                //console.log("print product");
                //console.log(this.personaliseData.to_print.products);
                
                this.personaliseData.to_print.products = this.personaliseData.to_print.products.filter( e => e != this.personaliseData.competition_data.personalise_name_product.variant_id)
                //console.log(this.personaliseData.to_print.products);
            }
        }
        if (request.action == "update_number"){
            this.personaliseData.to_print.number = request.data;
            if (this.personaliseData.to_print.number == "-"){
                this.personaliseData.to_print.number = "";
            }
            if (this.personaliseData.to_print.number > 0){
                if (!this.personaliseData.to_print.products.includes(this.personaliseData.competition_data.personalise_number_product.variant_id)){
                    this.personaliseData.to_print.products.push(this.personaliseData.competition_data.personalise_number_product.variant_id);
                }
            } else {
                //console.log("print product");
                //console.log(this.personaliseData.to_print.products);
                this.personaliseData.to_print.products = this.personaliseData.to_print.products.filter( e => e != this.personaliseData.competition_data.personalise_number_product.variant_id)
                //console.log(this.personaliseData.to_print.products);
                
            }
                    
        }
        if (request.action == "remove_badge"){
            this.personaliseData.badges_products = this.personaliseData.badges_products.filter(item => {
                if (item != request.data.vid){
                    return item;
                }
            })
            this.badgeSamePositionChecker(request);
        }
        if (request.action == "add_badge"){
            if (!this.personaliseData.badges_products.includes(request.data.vid)){
                this.personaliseData.badges_products.push(request.data.vid);
                this.badgeSamePositionChecker(request);
            }
        }

       //$("#kit_builder_name_input").val(this.personaliseData.to_print.name);//.change();
        //$("#kit_builder_number_picker").find('option:selected').removeAttr("selected");
        //alert(this.personaliseData.to_print.number);
        //$("#kit_builder_number_picker option[value="+this.personaliseData.to_print.number+"]").attr('selected','selected');//.change();
        //$("#kit_builder_number_picker").val(this.personaliseData.to_print.number);
       //console.log(this.personaliseData);
       
       this.showPersonalisePreview();
       this.updateURL();
       //if (request.action != "update_name"){
        this.addOptionPriceToMainProduct(this.sectionID);
       //}
       this.updateYourOwnLablePrice();
        
      }

      
      onSubmitHandler(evt){
        $("#uzkb_form_errors").hide();
        $("#kit_builder_player_picker").removeClass("uzkb__errors_field");
        $("#kit_builder_name_input").removeClass("uzkb__errors_field");
        $("#kit_builder_number_picker").removeClass("uzkb__errors_field");
        if (this.personaliseData.type =="none"){
        } else if (this.personaliseData.type =="player"){
            if ( (this.personaliseData.to_print.name.length <=0) || (this.personaliseData.to_print.number <= 0)){
                this.showFormError("player");
                return false;
            }
        } else {
            if (this.selCompetitionData.product_type==0){
                //short
                if ( ($("#kit_builder_number_picker").val() == "-")){
                    this.showFormError("your_own");
                    return false;    
                }
            } else {
                //shirt
                if (this.selCompetitionData.name_number_separate){
                    //name number separate
                    if ( ($("#kit_builder_name_input").val() == "") && ($("#kit_builder_number_picker").val() == "-")){
                        this.showFormError("your_own");
                        return false;    
                    }
                } else {
                    //name number as bundle
                    if ( ($("#kit_builder_name_input").val() == "") || ($("#kit_builder_number_picker").val() == "-")){
                        this.showFormError("your_own");
                        return false;    
                    }
                }
                if (this.personaliseData.to_print.name.length > 0){
                    if (!this.isValidPrintName(this.personaliseData.to_print.name)){
                        this.showFormError("wrong_name_format");
                        return false;
                    };
                }
                
            }
            
        }
        if (this.selCompetitionData.badge_required){
            //check if badge selected when badge required for personalise
            if (this.personaliseData.type !="none"){
                if (this.personaliseData.badges_products.length <= 0){
                    this.showFormError("missing_badge");
                }
                //alert(this.personaliseData.badges_products.length);
            }
        }

        
        
        if (this.submitButton.attr('aria-disabled') === 'true') return;
        
        //this.submitButton.addClass('loading');
        this.submitButton.attr('aria-disabled', true);
        this.submitButton.addClass('loading');
        this.submitButton.find(".loading-overlay__spinner").removeClass('hidden');
        
        var _shirt_vid = $("#"+this.productFormID+" input[name='id']").val();
        var formData ={ items:[] };
        if (this.productForm.cart){
            formData["form_type"] = 'product';
            formData["sections_url"] = window.location.pathname;
            formData["sections"] = this.productForm.cart.getSectionsToRender().map((section) => section.id);
        }
        this.productForm.cart.setActiveElement(document.activeElement);
        //console.log(formData);
        
        //handle main kitbuilder 
        //handle main kitbuilder for personalise: shirt
        var mainKBItem = {"id": _shirt_vid,
            "quantity": 1,
            properties: {
                '_kitbuilder':"main",
                '_competition_id':this.personaliseData.competition_data.id,
                'Competition':this.personaliseData.competition_data.competition_name,
                'Name': this.personaliseData.to_print.name,
                'Number':this.personaliseData.to_print.number,
                '_personalisation_type': this.personaliseData.type,
                'Badge':"",
                '_print_vids':"",
                '_badge_vids':""
            }
        }
        //handle main kitbuilder for personalise: short
        if (this.selCompetitionData.product_type==0){
            //short
            mainKBItem = {"id": _shirt_vid,
            "quantity": 1,
                properties: {
                    '_kitbuilder':"main",
                    '_competition_id':this.personaliseData.competition_data.id,
                    'Competition':this.personaliseData.competition_data.competition_name,
                    'Number':this.personaliseData.to_print.number,
                    '_personalisation_type': this.personaliseData.type,
                    'Badge':"",
                    '_print_vids':"",
                    '_badge_vids':""
                }
            }
        }
        //handle main kitbuilder for personalise: none
        
        if (this.personaliseData.type =="none"){
            mainKBItem.properties = {
                    '_kitbuilder':"main",
                    '_competition_id':this.personaliseData.competition_data.id,
                    'Competition':this.personaliseData.competition_data.competition_name,
                    '_personalisation_type': this.personaliseData.type,
                    'Badge':"",
                    '_print_vids':"",
                    '_badge_vids':""
                }
        } 
        //end handle main kitbuilder 

        Object.entries(this.personaliseData.badges_products).forEach(([key, value], index) => {
            formData.items.push({"id":value, "quantity":1, properties: {'_kitbuilder':"option"}});
            mainKBItem.properties["_badge_vids"] += value+",";
            //find badge title
            Object.entries(this.personaliseData.competition_data.badges).forEach(([k, v], i) => {
                if (v.product.variant_id == value){
                    mainKBItem.properties["Badge"] += v.label+",";
                }
            });
            
        });
        if (this.personaliseData.type =="none"){
            
        } else {
        
            Object.entries(this.personaliseData.to_print.products).forEach(([key, value], index) => {
                formData.items.push({"id":value, "quantity":1, properties: {'_kitbuilder':"option"}});
                mainKBItem.properties["_print_vids"] += value+",";
            });
        }

          // Inject additional properties
          for (const [key, value] of Object.entries(this.additionalProperties)) {
              mainKBItem.properties[key] = value;
          }
        
        formData.items.push(mainKBItem);


        fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
        })
        .then((response) => response.json())
        .then((response) => {
            //console.log(response);
            if (response.status) {
                this.productForm.handleErrorMessage(response.description);
                return;
    
                //const soldOutMessage = this.submitButton.find('.sold-out-message');
                
            }
            kitBuilder.submitButton.attr('aria-disabled', false);
            kitBuilder.submitButton.removeClass('loading');
            kitBuilder.submitButton.find(".loading-overlay__spinner").addClass('hidden');
    

            Object.entries(response.sections).forEach(([key, section], index) => {
                const html = new DOMParser().parseFromString(section, 'text/html');
                const content2Update = html.querySelector('#shopify-section-'+key);
                //console.log(key);
                if (key == "cart-notification-product"){
                    //console.log(content2Update);
                    $("#"+key).html("");
                    let newProductHtml = '<div id="shopify-section-cart-notification-product" class="shopify-section">';
                    Object.entries(response.items).forEach(([k, item], i) => {
                        newProductHtml += content2Update.querySelector('#cart-notification-product-'+item.key.replace(":","\\:")).outerHTML; 
                        
                    });
                    newProductHtml += '</div>';
                    $("#"+key).html(newProductHtml);
                } else {
                    $("#"+key).html(content2Update);
                }
                    
            });
            kitBuilder.productForm.cart.open();
        })
        .catch((error) => {
            console.error('Error:', error);
        }); 
        
        
        

    }
    showFormError(type){
        $("#uzkb_form_errors .error_type").hide();
        $("#uzkb_form_errors .error_player").hide();
        $("#uzkb_form_errors .error_your_own").hide();
        $("#uzkb_form_errors .error_swearword").hide();
        $("#uzkb_form_errors .error_wrong_name_format").hide();
        $("#uzkb_form_errors .error_missing_badge").hide();
        if (type == "type"){
            $("#uzkb_form_errors .error_type").show();
        }
        if (type == "player"){
            $("#uzkb_form_errors .error_player").show();
        }
        if (type == "your_own"){
            $("#uzkb_form_errors .error_your_own").show();
        }
        if (type == "swear_word"){
            $("#uzkb_form_errors .error_swearword").show();
        }
        if (type == "wrong_name_format"){
            $("#uzkb_form_errors .error_wrong_name_format").show();
        }
        if (type == "missing_badge"){
            $("#uzkb_form_errors .error_missing_badge").show();
        }
        $("#uzkb_form_errors").show();
        $("#kit_builder_player_picker").addClass("uzkb__errors_field");
        $("#kit_builder_name_input").addClass("uzkb__errors_field");
        $("#kit_builder_number_picker").addClass("uzkb__errors_field");
    }
    updateVariantID(varaintID){
        this.varaintID = varaintID;
    }
    getUrl(urlPrefix, varaintID){
        //console.log(this.personaliseData);
        
        let _url = `${urlPrefix}?variant=${varaintID}&cs=${this.personaliseData.competition_data.id}&type=${this.personaliseData.type}&pcidx=${this.personaliseData.player_list_idx}&pName=${this.personaliseData.to_print.name}&pNumber=${this.personaliseData.to_print.number}&pProducts=${this.personaliseData.to_print.products.join()}&badges=${this.personaliseData.badges_products.join()}`;
        return _url;
    }
    updateURL(){
        if (!this.varaintID){
            this.varaintID = $("#"+this.productFormID+" input[name='id']").val();
        }
        window.history.replaceState({ }, '', this.getUrl(`${window.location.pathname}`,`${this.varaintID}`));
       
        const shareButton = document.getElementById(`Share-${this.sectionID}`);
        if (!shareButton || !shareButton.updateUrl) {

        } else {
            shareButton.updateUrl(this.getUrl(`${window.shopUrl}${window.location.pathname}`,`${this.varaintID}`));
        }
    }
    updateYourOwnLablePrice(){
        let _minimumFractionDigits = 2;
        if (Shopify.currency_format == "without-decimals"){
            _minimumFractionDigits = 0;
        }
        let _money = Intl.NumberFormat('en', {
            style: 'currency',
            currency: Shopify.currency.active,
            minimumFractionDigits:_minimumFractionDigits
          });

        let _personalise_your_own_price = 0;
        if (this.selCompetitionData.name_number_separate){
            Object.entries(this.personaliseData.to_print.products).forEach(([key, value], i) => {
            
                if (value == this.personaliseData.competition_data.personalise_name_product.variant_id){
                    _personalise_your_own_price += parseInt(this.personaliseData.competition_data.personalise_name_product.price);
                }
                if (value == this.personaliseData.competition_data.personalise_number_product.variant_id){
                    _personalise_your_own_price += parseInt(this.personaliseData.competition_data.personalise_number_product.price);
                }
            });
        } else {
            if (this.selCompetitionData.product_type==0){
                //short
                _personalise_your_own_price += parseInt(this.personaliseData.competition_data.personalise_number_product.price);
            } else {
                //shirt combine
                _personalise_your_own_price += parseInt(this.personaliseData.competition_data.personalise_name_product.price);
                _personalise_your_own_price += parseInt(this.personaliseData.competition_data.personalise_number_product.price);
            }   
        }
        if (_personalise_your_own_price>0){
            _personalise_your_own_price = _personalise_your_own_price/100;
            $("#kit_builder_personalise_type_your_own_label").find(".personalise_price").html(" +"+_money.format(_personalise_your_own_price));
        } else {
            $("#kit_builder_personalise_type_your_own_label").find(".personalise_price").html("");
        }
    }
    getOptionsPrice(){
        //console.log("getOptionsPrice");
        let _optionPrice = 0;
        if (this.personaliseData.competition_data == null ){
            return {price:_optionPrice, compare_at_price:_optionPrice};
        }
        /*
        if (this.personaliseData.type=="none"){
            return {price:_optionPrice, compare_at_price:_optionPrice};
        }*/
        Object.entries(this.personaliseData.badges_products).forEach(([key, value], index) => {
            Object.entries(this.personaliseData.competition_data.badges).forEach(([k, v], i) => {
                if (v.product.variant_id == value){
                    _optionPrice += parseInt(v.product.price);
                }
            });
            
        });
        if (this.personaliseData.type=="none"){
        } else if (this.personaliseData.type == "player"){
            
            if (this.selCompetitionData.players.length > 0){
                _optionPrice += (parseInt(this.selCompetitionData.players[0].price));
            }
        } else {
            if (this.selCompetitionData.name_number_separate){
                Object.entries(this.personaliseData.to_print.products).forEach(([key, value], i) => {
                    if (value == this.personaliseData.competition_data.personalise_name_product.variant_id){
                        _optionPrice += parseInt(this.personaliseData.competition_data.personalise_name_product.price);
                    }
                    if (value == this.personaliseData.competition_data.personalise_number_product.variant_id){
                        _optionPrice += parseInt(this.personaliseData.competition_data.personalise_number_product.price);
                    }
                });
            } else {
                if (this.selCompetitionData.product_type==0){
                    _optionPrice += parseInt(this.personaliseData.competition_data.personalise_number_product.price);
                } else {
                    _optionPrice += parseInt(this.personaliseData.competition_data.personalise_name_product.price);
                    _optionPrice += parseInt(this.personaliseData.competition_data.personalise_number_product.price);
                }
            }
            
        }
        
        _optionPrice = _optionPrice/100;
        
        //console.log("_optionPrice: "+_optionPrice);

        return {price:_optionPrice, compare_at_price:_optionPrice};
    }
    updateOptionPrice(variant){
        const _optionPrices = kitBuilder.getOptionsPrice();
        //console.log(_optionPrices);
        let _priceHTML = $(`#price-${kitBuilder.sectionID}`);

        let _price = parseFloat(variant.price);
        let _compare_at_price = parseFloat(variant.compare_at_price);
        //console.log("_price: "+_price);
        //console.log("_compare_at_price: "+_compare_at_price);
        let _onSale = false;
        if (isNaN(_compare_at_price)){
            _compare_at_price = _price;
        }
        if ((_compare_at_price>_price) ){
            //main product on sale
            _onSale = true;
        } 
        if (_optionPrices.compare_at_price > _optionPrices.price){
            // option on sale
            _onSale = true;
        }
        _price += _optionPrices.price;
        _compare_at_price += _optionPrices.compare_at_price;
        let _minimumFractionDigits = 2;
        if (Shopify.currency_format == "without-decimals"){
            _minimumFractionDigits = 0;
        }
        let _money = Intl.NumberFormat('en', {
          style: 'currency',
          currency: Shopify.currency.active,
          minimumFractionDigits:_minimumFractionDigits
        });
        //${currencySymbol}
        //console.log("price: "+pounds.format(_price)+ " : "+_compare_at_price);
        _priceHTML.find(".price__regular").find(".price-item--regular").html(`${_money.format(_price)}`);
        _priceHTML.find(".price__sale").find(".price-item--regular").html(`${_money.format(_compare_at_price)}`);
        _priceHTML.find(".price__sale").find(".price-item--last").html(`${_money.format(_price)}`);
        if (_onSale){
            _priceHTML.addClass("price--on-sale");
        } else {
            _priceHTML.removeClass("price--on-sale");
        }
    }
    addOptionPriceToMainProduct(sectionID){
        //console.log("addOptionPriceToMainProduct");
        /*console.log(priceHTML.html());
        priceHTML.find(".price--large").removeClass("price--on-sale");
        console.log(priceHTML.find(".price--large").html());
        let regularPriceContainer = $(priceHTML).find(".price__regular");
        let regularPrice = $(regularPriceContainer).find(".price-item--regular").html();
        let salePriceContainer = $(priceHTML).find(".price__sale");
        let salePrice = $(salePriceContainer).find(".price-item--last").html();
        let comparePrice = $(salePriceContainer).find(".price-item--regular").html()*/
        //console.log(parseFloat("dd£55.5")+" : "+parseFloat(salePrice)+" : "+parseFloat(comparePrice));
        if (!this.varaintID){
            this.varaintID = $("#"+this.productFormID+" input[name='id']").val();
        } else {
            if (this.savedVariant != null && this.savedVariant.id == this.varaintID){
                //update price 
                this.updateOptionPrice(this.savedVariant);
                return;
            }
        }
                
        const requestedVariantId = this.varaintID;
    

        fetch(`${window.shopUrl}${window.location.pathname}.json`)
        .then((response) => response.json())
        .then((responseJson) => {
            // prevent unnecessary ui changes from abandoned selections
            if (this.varaintID !== requestedVariantId) return;

            Object.entries(responseJson.product.variants).forEach(([key, variant], index) => {
                //console.log(variant);
                if (variant.id == requestedVariantId){
                    kitBuilder.savedVariant = variant;
                    kitBuilder.updateOptionPrice(kitBuilder.savedVariant);
                }
            });

        });

    }
    isSwearWord(val){
        //
        if (this.swearWords.length == 0){
            return false;
        }
        if (this.swearWords.length == 1){
            if (this.swearWords[0] == ""){
              return false;
            }
        }
        /*
        const myRe = /\bfuck+(?:(?:\s+)?[esdingr]+)?|F+(?:(?:\s+)?[\sESDITCHNGR]+)?|f+(?:(?:\s+)?[btchesdrgin]+)+[^bitsed]/g;
        const myArray = myRe.exec(val);
        console.log(myArray);
        if (myArray != null){
          return true;
        } else {
          return false;
        }*/
        // "i" is to ignore case and "g" for global
        //var rgx = /fuck|bitch|shit\b/gi;
        var i = 0;
        while (i < this.swearWords.length) {
            if (this.swearWords[i] === "") {
                this.swearWords.splice(i, 1);
            } else {
                ++i;
            }
        }
        var rgx = new RegExp(this.swearWords.join("|")+'|fuck\\b', 'gi');
        //console.log(rgx);
        const myArray = rgx.exec(val);
        //console.log(myArray);
        if (myArray != null){
          return true;
        } else {
          return false;
        }
      
    }
    isValidPrintName(name){

        if (this.isSwearWord(name) && (uzkd_config.block_add_to_cart_when_swear_words == "true")){
            return false;
        }
        return true;

        /*
        var rgx = new RegExp("[^"+kitBuilder.personalise_name_regex+"]", 'g');
        var _print_name = this.personaliseData.to_print.name;
        _val = _val.replace(rgx, '');
        $(this).val(_val); 

        return false*/
    }
    
}